import React, { Component } from 'react';
import Input from '../../Forms/Input';
import {connect} from 'react-redux';
import { Link ,Navigate } from 'react-router-dom';
import Settings from '../../../inc/Settings';
import Api from '../../../inc/Api';
import Helper from '../../../inc/Helper';
import ActionTypes from '../../../inc/ActionsTypes';
import FormValidator from '../../../inc/FormValidator';
import { requestPermission } from '../../../services/Firebase/FirebaseServiceFunctions';
import { getPopupMessageBasedOnStatus } from '../../../inc/Validation';
import RsWithRouter from '../../inc/RsWithRouter';

class LoginForm extends Component {
    constructor(props){
        super(props);
        this.state = {
            email: '',
            password: '',
            isFormSubmited:false,
            message:null,
            messageType:'fail',
            isLogin:false
        }
        this.validationConfigure();
    }
    validationConfigure(){
        const language = this.props.language;
        let fieldConfig = [
            {name:'email',displayName:Helper.getLabel(language,'email','Email'),types:['Required','Email'],max:80 },
            {name:'password',displayName:Helper.getLabel(language,'password','Password'),types:['Required'],min:5,max:80 },
            //{name:'isactive',displayName:Helper.getLabel(language,'active','Active'),types:['Required']},
        ]
        this.validator = new FormValidator(fieldConfig,language);
    }
    onChangeHandeler(e){
        this.setState({
            ...this.state,
            [e.target.name]:e.target.value
        })
    }
    async onLoginClickHandler(e){                                           
        let formData = {
            username: this.state.email,
            password: this.state.password 
        };
        let that = this;
        this.setState({
            isFormSubmited:true,
            message:null,
            messageType:'fail',
            isLogin:false
        });
        if(!this.state.email){
            Helper.alert('Please provide email!', 'error');
            return;
        }
        if(!this.state.password){
            Helper.alert('Please provide password!', 'error');
            return;
        }
        let api = Api;
        api.setJsonHeader();
        api.axios().post(Settings.apiUrl + '/auth/token/', formData).then(function(apiResponse){
            if(apiResponse?.data){ 
                const defaultDataFormate = 'dd/mm/yyyy';
                const location = window.location.href;
                const match = location.match(/\/\/([a-zA-Z0-9-]+)\./);
                const subdomain = match ? match[1] : null;
 
                //set user token to browser
                Helper.setCookie(Settings.userTokenKey, apiResponse?.data?.access, Settings.userTokenExpireDate);
                Helper.setCookie(Settings.dateFormateKey, defaultDataFormate);
                Helper.setCookie(Settings.tenantSubdomain, subdomain)
                that.props.setDateFormate(defaultDataFormate);
                 
                api.setUserToken();
                api.axios().get(Settings.apiUrl+'/auth/user/me/', {}).then(function(loginResponse){ 
                    if(loginResponse && loginResponse?.status === 200){ 
                        that.props.setUser(loginResponse?.data);
                        that.props.login(loginResponse?.data);  
                    } else {
                        window.location.href = '/login';
                    }
                })
            } else {
                that.setState({
                    isFormSubmited:false,
                    messageType: 'fail',
                    message: null,
                    isLogin:true
                });
            }
        }).catch(error => { 
            that.setState({
                message: error.code  == 'ERR_NETWORK' ? "Network not working. please try again" : (error && error.response ? error.response.data.message : ''),
                isFormSubmited:false
            });
            if(error?.response?.status === 401){
                Helper.alert(error?.response?.data?.detail, 'error');
            }else {
                getPopupMessageBasedOnStatus(error)
            }   
        })
    }
    onKeyPreshHander(event){
        if(event.key =='Enter'){
            this.onLoginClickHandler(event);
        }
    }
    render() {
        if(this.state.isLogin){
            return <Navigate to = {'/' + Settings.redirectUrlAfterLogin}/>
        }
        return (
            <div className='login_form_group'>
                <div className='lf_title_subtitle'>
                    <h2>Sign in to your account</h2>
                    <p>Enter your login details below</p>
                </div>
                <Input label="Email" hasError={this.validator.hasError('email')}  inputType="email" placeholder="Email" name="email" onKeyPress={ this.onKeyPreshHander.bind(this)} value={this.state.email} onChange= { e => this.onChangeHandeler(e) } placeHolder = "Please enter your email" />
                <Input label="Password" hasError={this.validator.hasError('password')} inputType="password" placeholder="password"  onKeyPress={ this.onKeyPreshHander.bind(this)} value={this.state.password} onChange= { e => this.onChangeHandeler(e) } name="password" placeHolder="Enter password" />
                <p className="pwr_link"><Link to="/rest-password">Forgot your password?</Link></p>
                { this.state.message ? <p className={this.state.messageType ==='Success' ? 'alert alert-success' : 'alert alert-danger' }>{this.state.message}</p> : ''}
                <button className='btn btn_block btn_active sb_btn' onClick={ e => this.onLoginClickHandler(e)}>Sign In <img src="/images/icons/arrow-right-white.svg" alt="Sign In" /> {this.state.isFormSubmited ? <output className="spinner-border spinner-border-sm" aria-hidden="true"></output> : ''}</button>
            </div>
        );
    }
}
const mapStateToProps = (state) => {
    return {
        language:state.language,
        auth:state.auth
    }
}
const mapDispatchToProps = (dispatch) => {
    return {
        //date_format
        setDateFormate:(formate) => { dispatch({type:ActionTypes.SET_DATE_FORMATE , payload:formate}) },
        login:(user) => { dispatch({type:ActionTypes.SET_LOGIN , payload:user}) },
        setUser:(user) => { dispatch({type:ActionTypes.SET_USER , payload:user}) },
    }
}
export default connect(mapStateToProps,mapDispatchToProps) ((LoginForm));